import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Smartphone } from 'lucide-react';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';
import { Button } from './ui/button';

export const SellerPaymentInfo = () => {
  const { user, refresh } = useAuth();
  const [wave, setWave] = useState('');
  const [om, setOm] = useState('');
  useEffect(() => { setWave(user?.wave_number || ''); setOm(user?.orange_number || ''); }, [user]);
  const missing = !(user?.wave_number || user?.orange_number);
  const [block, setBlock] = useState(null);
  useEffect(() => { api.get('/me/commission-block').then(({ data }) => setBlock(data.blocked ? data.message : null)).catch(() => {}); }, [user]);

  const save = async () => {
    try {
      await api.put('/me/payment-info', { wave_number: wave, orange_number: om });
      toast.success('Numéros enregistrés : les acheteurs les verront après avoir gagné');
      refresh && refresh();
    } catch (e) { toast.error(e?.response?.data?.detail || 'Erreur'); }
  };

  return (
    <>
    {block && (
      <div className="rounded-2xl p-4 bg-rose-600/15 border border-rose-500/50 text-rose-200 text-sm font-semibold" data-testid="commission-block-banner">
        🚫 {block}
      </div>
    )}
    <section className={`card-elev rounded-2xl p-5 ${missing ? 'border border-amber-500/50' : ''}`} data-testid="seller-payment-info">
      <h2 className="font-display text-xl font-bold flex items-center gap-2"><Smartphone className="h-5 w-5 text-cyan-400" />Mes numéros de paiement</h2>
      <p className="text-sm text-slate-400 mt-1">
        {missing ? <span className="text-amber-300 font-semibold">⚠ Indispensable : </span> : null}
        Les acheteurs qui gagnent vos enchères vous paient directement sur ces numéros.
      </p>
      <div className="grid sm:grid-cols-[1fr_1fr_auto] gap-2 mt-3">
        <input data-testid="wave-number-input" value={wave} onChange={(e) => setWave(e.target.value)} placeholder="Numéro Wave (+221 77 …)"
          className="px-3 py-2 rounded-xl bg-slate-900 border border-slate-700 text-white outline-none" />
        <input data-testid="om-number-input" value={om} onChange={(e) => setOm(e.target.value)} placeholder="Numéro Orange Money (+221 78 …)"
          className="px-3 py-2 rounded-xl bg-slate-900 border border-slate-700 text-white outline-none" />
        <Button data-testid="save-payment-info" onClick={save} className="bg-cyan-500 hover:bg-cyan-400 text-slate-900 font-bold">Enregistrer</Button>
      </div>
    </section>
    </>
  );
};
